// extracted by mini-css-extract-plugin
export default {"userPageWrapper":"AdminUserPage_userPageWrapper__pC2cH"};